import { render, staticRenderFns } from "./OsSWForm.vue?vue&type=template&id=8f8e16dc"
import script from "./OsSWForm.vue?vue&type=script&lang=js"
export * from "./OsSWForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports